var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHmNewMemberLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 0C18.0746 0 19.9128 1.05142 21.2158 2.54296C22.5171 4.03261 23.333 6.01309 23.333 7.97897C23.333 9.94441 22.431 12.2504 21.123 14.0553C19.8323 15.8364 17.9923 17.3333 15.9999 17.3333C14.0295 17.3333 12.1894 15.9749 10.883 14.2303C9.5627 12.467 8.66683 10.1581 8.66683 7.97897C8.66683 3.6502 11.8923 0 15.9999 0ZM15.9999 1.33333C12.744 1.33333 10.0002 4.26569 10.0002 7.97897C10.0002 9.82092 10.7708 11.8559 11.9503 13.4311C13.1438 15.0251 14.637 16 15.9999 16C17.3411 16 18.8343 14.9415 20.0434 13.2729C21.2352 11.6281 21.9996 9.59024 21.9996 7.97897C21.9996 6.36816 21.3231 4.69248 20.2116 3.42015C19.1019 2.14972 17.607 1.33333 15.9999 1.33333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 18C11.3335 18.3682 11.035 18.6667 10.6668 18.6667L10.4074 18.6726L10.0586 18.6927L9.63016 18.7299C9.55265 18.7378 9.47222 18.7464 9.38908 18.756C8.41834 18.868 7.4489 19.0694 6.55157 19.38C4.18712 20.1985 2.78678 21.5845 2.67419 23.7175L2.66683 24V30C2.66683 30.3682 2.36835 30.6667 2.00016 30.6667C1.67288 30.6667 1.40068 30.4308 1.34424 30.1198L1.3335 30V24C1.3335 21.044 3.16601 19.141 6.11542 18.12C7.11392 17.7744 8.17573 17.5538 9.23625 17.4315C9.48324 17.403 9.71869 17.3812 9.94014 17.3654L10.3936 17.34L10.6668 17.3333C11.035 17.3333 11.3335 17.6318 11.3335 18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6067 17.34L21.3335 17.3333C20.9653 17.3333 20.6668 17.6318 20.6668 18C20.6668 18.3682 20.9653 18.6667 21.3335 18.6667C21.3687 18.6667 21.4081 18.6671 21.4514 18.6681L21.7567 18.6807L22.1466 18.7089L22.6112 18.756C23.5819 18.868 24.5514 19.0694 25.4487 19.38C27.9159 20.234 29.3334 21.706 29.3334 24L29.3335 30C29.3335 30.3682 29.632 30.6667 30.0002 30.6667C30.3684 30.6667 30.6668 30.3682 30.6668 30L30.6667 24L30.6597 23.6873C30.5344 20.9092 28.7289 19.1045 25.8848 18.12C24.8864 17.7744 23.8246 17.5538 22.7641 17.4315C22.3936 17.3887 22.0491 17.3612 21.7388 17.3459L21.6067 17.34Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1486_41952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5625 3.28125H28.7188V0.4375H28.2812V3.28125H25.4375V3.71875H28.2812V6.5625H28.7188V3.71875H31.5625V3.28125Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1486_41952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "currentColor",
    transform: "translate(25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmNewMemberLogo);
export default __webpack_public_path__ + "static/media/HM-NewMemberLogo.2cea666a4a61e7db24b2dd7e65d652e7.svg";
export { ForwardRef as ReactComponent };